import api from 'api';
import { DesignTemplates } from 'records/DesignTemplate';

export const SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_START = 'SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_START';
export const SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_ERROR = 'SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_ERROR';
export const SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_SUCCESS = 'SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const SEARCH_BG_RESULT_TEMPLATES_RESET_STATE = 'SEARCH_BG_RESULT_TEMPLATES_RESET_STATE';

function searchBgResultDesignTemplatesAsyncActionStart() {
  return {
    type: SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_START,
  };
}

function searchBgResultDesignTemplatesAsyncActionError(error) {
  return {
    type: SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function searchBgResultDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: SEARCH_BG_RESULT_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetsearchBgResultDesignTemplatesState() {
  return {
    type: SEARCH_BG_RESULT_TEMPLATES_RESET_STATE,
  };
}

export function getsearchBgResultDesignTemplates( typeId, designTypeId, designSizeId, themeName ) {
  switch (themeName) {
    case 'GRAPHIC':
    case 'OCCASION':
      return (dispatch, getState) => {
        
        dispatch(resetsearchBgResultDesignTemplatesState());
        dispatch(searchBgResultDesignTemplatesAsyncActionStart());
        return api.request(
          `theme/design/DesignTemplates?themeid=${ typeId }&designtid=${ designTypeId }&sizeid=${ designSizeId }`,
          'get',
          null
        )
        .then((data) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionSuccess(data));
          return DesignTemplates(data);
        })
        .catch((err) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionError('There are no search design templates'));
          throw (err);
        });
      };
    default:
    // case 'CUISINE TYPE':
    // case 'BUSINESS TYPE':
    // case 'COLOR':
      return (dispatch, getState) => {
        
        dispatch(resetsearchBgResultDesignTemplatesState());
        dispatch(searchBgResultDesignTemplatesAsyncActionStart());
        return api.request(
          `design/designtemplates/typeitem?typeId=${ typeId }&designtid=${ designTypeId }&sizeid=${ designSizeId }`,
          'get',
          null
        )
        .then((data) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionSuccess(data));
          return DesignTemplates(data);
        })
        .catch((err) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionError('There are no search design templates'));
          throw (err);
        });
      };
  }
}

export function getsearchBgResultThemeDesignTemplates( typeId, themeName ) {
  switch (themeName) {
    case 'GRAPHIC':
    case 'OCCASION':
      return (dispatch, getState) => {
        
        dispatch(resetsearchBgResultDesignTemplatesState());
        dispatch(searchBgResultDesignTemplatesAsyncActionStart());
        return api.request(
          `theme/design/DesignTemplates?themeid=${ typeId }`,
          'get',
          null
        )
        .then((data) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionSuccess(data));
          return DesignTemplates(data);
        })
        .catch((err) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionError('There are no search design templates'));
          throw (err);
        });
      };
    default:
    // case 'CUISINE TYPE':
    // case 'BUSINESS TYPE':
    // case 'COLOR':
      return (dispatch, getState) => {
        
        dispatch(resetsearchBgResultDesignTemplatesState());
        dispatch(searchBgResultDesignTemplatesAsyncActionStart());
        return api.request(
          `design/designtemplates/typeitem?typeId=${ typeId }`,
          'get',
          null
        )
        .then((data) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionSuccess(data));
          return DesignTemplates(data);
        })
        .catch((err) => {
          dispatch(searchBgResultDesignTemplatesAsyncActionError('There are no search design templates'));
          throw (err);
        });
      };
  }
}
